import React, { Component } from 'react';
import { observer } from "mobx-react";
import pageLoader from '../images/loader_big.svg';
import _ from 'lodash';

import { CostStatState, PurchaseStatState, RawStatState, RevisionStatState, WriteOffStatState, SalesStatState, WorkShopStatState } from '../stores/statistics';
import { CancelReasonApi, ProductApi, ProviderApi, getSectionsList, getWorkShopsList, StockReportApi } from '../stores/apiMethods';

import { Selectize, CheckFilter, TextInput } from '../forms/FormItems';
import { EmptyResultInformer } from '../shared/FeedbackComponents';
import { ExpandIconButton, FilterIconButton, MainFilterBlock } from '../shared/PageComponents';

import { toSelectList, getRubs } from '../functions';

/** Общая оболочка страницы складской статистики */
export class StockStatisticPage extends Component {
	constructor(props) {
		super(props);
		this.state = { isOpen : false };
	}

	render() {
		const {
			Id, Title, store, getData, MaxDate, Details, TableClass, children, ClassName = ""
		} = this.props;

		return (
			<div className={(ClassName + " page StatPage").trim()} id={Id}>
				<div className="head">
					<FilterHeadBlock
						Title={Title}
						isOpen={this.state.isOpen}
						toggleFilter={() => this.setState({ isOpen : !this.state.isOpen })}
					/>
					<Filter
						store={store}
						isOpen={this.state.isOpen}
						MaxDate={MaxDate}
						getData={getData}
					/>
				</div>
				{children}
				<TableBlock
					IsSendRequest={store.IsSendRequest}
					IsEmptyResponse={store.IsEmptyResponse}
					Columns={store.columns}
					Report={store.Report}
					Total={store.Total}
					Details={Details}
					TableFilter={store.TableFilter}
					TableClass={TableClass}
					onChange={store.collect.bind(store)}
				/>
			</div>
		)
	}
}
StockStatisticPage = observer(StockStatisticPage);

export class WorkShopsSummary extends Component {
	constructor(props) {
		super(props);
		this.store = new WorkShopStatState();
	}

	/** Загрузка отчёта и справочников разделов и цехов после открытия страницы */
	componentDidMount() {
		getSectionsList((data) => {
			this.store.SectionList = data.Success ? _.filter(data.Sections, { Type : 3 }) : [];
		});
		getWorkShopsList((data) => { this.store.WorkShops = data.Success ? data.WorkShops : []; });
		this.getData();
	}

	/**
	 * API запрос «GetWorkshopLoadReport» для получения статистики по себестоимости
	 */
	getData() { 
		this.store.IsSendRequest = false;
		StockReportApi.getWorkShop(this.store.Filter.getData(), (data) => { this.store.setStat(data); });
	}

	render() {
		return (
			<StockStatisticPage
				Id="WorkShopStat"
				Title="Отчет по загрузке цехов"
				store={this.store}
				getData={this.getData.bind(this)}
				Details={WorkShopStatDetails}
			/>
		)
	}
}
WorkShopsSummary = observer(WorkShopsSummary)

class WorkShopStatDetails extends Component {
	render() {
		return(
			<div className='details'>
				<h4>Детализация по товарам</h4>
				<div className='reportTable'>
					<span className='title'>Название</span>
					<span className='title'>Количество</span>
					<span className='title'>Сумма, руб.</span>
					{_.map(this.props.Items, (item, i) => {
						return <WorkShopStatDetailsRow Item={item} key={"P_" + i} />
					})}
				</div>
			</div>
		)
	}
}

class WorkShopStatDetailsRow extends Component {
	render() {
		return(
			<>
				<p>{this.props.Item.Name}</p>
				<p>{this.props.Item.Count}</p>
				<p>{this.props.Item.Amount}</p>
			</>
		)
	}
}

export class SalesStat extends Component {
	constructor(props) {
		super(props);
		this.store = new SalesStatState();
	}

	componentDidMount() {
		ProductApi.getList({ Active : true }, (data) => {
			this.store.ProductList = data.Success ? _.filter(data.Products, { Type : 3 }) : [];
		});
		getSectionsList((data) => {
			this.store.SectionList = data.Success ? _.filter(data.Sections, { Type : 3, IsHidden : false, System : false }) : [];
		});
		
		this.getData();
	}

	getData() { 
		if (this.store.Filter.OutForm === "json") this.store.IsSendRequest = false;
		StockReportApi.getSales(this.store.Filter.getData(), (data) => { this.store.setStat(data)})
	}

	render() {
		return (
			<StockStatisticPage Id="SalesStatPage" Title="Отчет по продажам" store={this.store}
				getData={this.getData.bind(this)} MaxDate="today" />
		)
	}
}
SalesStat = observer(SalesStat);


/** ----- Статистика по себестоимости
 * На данной странице отображаются все товары по разделам 
 *  - для конечной продукции с указанием себестоимости, маржи, наценки и количество проданных товаров
 *  - для полуфабрикатов только себестоимость
 */
export class CostStat extends Component {
	constructor(props) {
		super(props);
		this.store = new CostStatState();
	}

	/** Загрузка отчёта и справочника разделов после открытия страницы */
	componentDidMount() {
		getSectionsList((data) => { this.store.SectionList = data.Success ? data.Sections : []; });
		this.getData();
	}

	/**
	 * API запрос «StatCost» для получения статистики по себестоимости
	 */
	getData() { 
		if (this.store.Filter.OutForm === "json") this.store.IsSendRequest = false;
		StockReportApi.getCost(this.store.Filter.getData(), (data) => { this.store.setStat(data); });
	}

	render() {
		return (
			<StockStatisticPage Id="CostStat" Title="Отчет по себестоимости" store={this.store}
				getData={this.getData.bind(this)} MaxDate="today" Details={CostStatDetails}
				TableClass={this.store.Filter.Type === 2 ? "short" : ""} ClassName="clearfix" />
		)
	}
}
CostStat = observer(CostStat);

class CostStatDetails extends Component {
	render() {
		return(
			<div className='details'>
				<h4>Детализация по составу</h4>
				<div className='reportTable'>
					<span className='title'>Название</span>
					<span className='title'>Количество</span>
					<span className='title'>Цена за ед.</span>
					<span className='title'>Сумма, руб.</span>
					{_.map(this.props.Items, (item, i) => {
						return <CostStatDetailsRow Item={item} key={"CP_" + i} />
					})}
				</div>
			</div>
		)
	}
}

class CostStatDetailsRow extends Component {
	render() {
		return(
			<>
				<p>{this.props.Item.Product}</p>
				<p>{this.props.Item.Count} {this.props.Item.Unit}</p>
				<p>{getRubs(this.props.Item.UnitCost, true, true)} руб./{this.props.Item.Unit}</p>
				<p>{getRubs(this.props.Item.CountCost, true, true)}</p>
			</>
		)
	}
}

export class RawStat extends Component {
	constructor(props) {
		super(props);
		this.store = new RawStatState();
	}

	/** Загрузка отчёта и справочников товаров и разделов после открытия страницы */
	componentDidMount() {
		ProductApi.getList({ Active : true }, (data) => {
			this.store.ProductList = data.Success ? _.filter(data.Products, (item) => item.Type === 1 || item.Type === 2) : [];
		});
		getSectionsList((data) => { this.store.SectionList = data.Success ? data.Sections : []; });
		this.getData();
	}

	/** API запрос «StatRawMovement» с одновременным разбором ответа новым и старым состояниями */
	getData() {
		if (this.store.Filter.OutForm === "json") {
			this.store.IsSendRequest = false;
		}
		StockReportApi.getRawMovement(this.store.Filter.getData(), (data) => {
			this.store.setStat(data);
		});
	}

	render() {
		return (
			<StockStatisticPage Id="RawStat" Title="Отчет по движению сырья" store={this.store}
				getData={this.getData.bind(this)} MaxDate="today"
				TableClass={"columns" + this.store.columns.length} />
		)
	}
}
RawStat = observer(RawStat);

export class PurchaseStat extends Component {
	constructor(props) {
		super(props);
		this.store = new PurchaseStatState();
	}

	/** Загрузка отчёта и справочников товаров, разделов и поставщиков после открытия страницы */
	componentDidMount() {
		ProductApi.getList({ Active : true }, (data) => {
			this.store.ProductList = data.Success ? _.filter(data.Products, { Type : 1 }) : [];
		});
		getSectionsList((data) => {
			this.store.SectionList = data.Success ? data.Sections : [];
		});
		ProviderApi.getList(true, (data) => {
			this.store.Providers = data.Success ? data.Providers : [];
		});
		this.getData();
	}

	/** API запрос «StatPurchase» для получения отчёта по накладным в виде отчёта или файла */
	getData() {
		if (this.store.Filter.OutForm === "json") this.store.IsSendRequest = false;
		StockReportApi.getPurchase(this.store.Filter.getData(), (data) => { this.store.setStat(data); });
	}

	render() {
		return (
			<StockStatisticPage Id="PurchaseStat" Title="Отчет по накладным" store={this.store}
				getData={this.getData.bind(this)} MaxDate="today" Details={PurchaseStatDetails}
				TableClass={this.store.TableFilter.Summary ? "summary" : ""} />
		)
	}
}
PurchaseStat = observer(PurchaseStat);

/** Детализация накладных, вошедших в сводную строку товара и поставщика */
class PurchaseStatDetails extends Component {
	render() {
		return(
			<div className="details">
				<h4>Детализация по накладным</h4>
				<div className="reportTable">
					<span className="title">Дата</span>
					<span className="title">Номер</span>
					<span className="title">Количество</span>
					<span className="title">Сумма, руб.</span>
					{_.map(this.props.Items, (item, i) => {
						return <PurchaseStatDetailsRow Item={item} key={"PI_" + i} />
					})}
				</div>
			</div>
		)
	}
}

/** Строка отдельной накладной в детализации сводного отчёта */
class PurchaseStatDetailsRow extends Component {
	render() {
		return(
			<>
				<p>{this.props.Item.Date}</p>
				<p>{this.props.Item.Invoice}</p>
				<p>{this.props.Item.Count}</p>
				<p>{this.props.Item.Amount}</p>
			</>
		)
	}
}

export class RevisionStat extends Component {
	constructor(props) {
		super(props);
		this.store = new RevisionStatState();
	}

	/** Загрузка отчёта и справочников товаров и разделов после открытия страницы */
	componentDidMount() {
		ProductApi.getList({ Active : true }, (data) => { this.store.ProductList = data.Success ? data.Products : []; });
		getSectionsList((data) => { this.store.SectionList = data.Success ? data.Sections : []; });
		this.getData();
	}

	/** API запрос «StatRevisions» для получения отчёта по ревизиям */
	getData() {
		if (this.store.Filter.OutForm === "json") this.store.IsSendRequest = false;
		StockReportApi.getRevision(this.store.Filter.getData(), (data) => { this.store.setStat(data); });
	}

	render() {
		return (
			<StockStatisticPage Id="RevisionStat" Title="Отчет по ревизиям" store={this.store}
				getData={this.getData.bind(this)} MaxDate="today" />
		)
	}
}
RevisionStat = observer(RevisionStat);


export class WriteOffStat extends Component {
	constructor(props) {
		super(props);
		this.store = new WriteOffStatState();
	}

	/** Загрузка отчёта и справочников товаров, разделов и причин списания после открытия страницы */
	componentDidMount() {
		this.getData();

		ProductApi.getList({ Active : true }, (data) => { this.store.ProductList = data.Success ? data.Products : []; });
		getSectionsList((data) => { this.store.SectionList = data.Success ? data.Sections : []; });
		CancelReasonApi.getList((data) => { this.store.CancelReasons = data.Success ? data.CancelReasons : []; });
	}

	/** API запрос «WriteOffStat» для получения отчёта по параметрам фильтра */
	getData() { 
		this.store.IsSendRequest = false;
		StockReportApi.getWriteOff(this.store.Filter.getData(), (data) => {
			this.store.setStat(data);
		});
	}

	render() {
		return (
			<StockStatisticPage Id="WriteOffStat" Title="Отчет по списаниям" store={this.store}
				getData={this.getData.bind(this)} MaxDate="today" Details={WriteOffStatDetails}
				TableClass={this.store.TableFilter.Summary ? "summary" : ""} />
		)
	}
}
WriteOffStat = observer(WriteOffStat);

/** Детализация отдельных операций сгруппированной строки списаний */
class WriteOffStatDetails extends Component {
	render() {
		return(
			<div className='details'>
				<h4>Детализация по списаниям</h4>
				<div className='reportTable'>
					<span className='title'>Дата</span>
					<span className='title'>Количество</span>
					<span className='title'>Сумма, руб.</span>
					<span className='title'>Склад</span>
					<span className='title'>Комментарий</span>
					{_.map(this.props.Items, (item, i) => {
						return <WriteOffStatDetailsRow Item={item} key={"WO_" + i} />
					})}
				</div>
			</div>
		)
	}
}

/** Строка отдельной операции в детализации сгруппированного списания */
class WriteOffStatDetailsRow extends Component {
	render() {
		return(
			<>
				<p>{this.props.Item.Date}</p>
				<p>{this.props.Item.Count}</p>
				<p>{this.props.Item.Amount}</p>
				<p>{this.props.Item.Stock}</p>
				<p>{this.props.Item.Description}</p>
			</>
		)
	}
}

/** Шапка отчёта с кнопкой показа расширенных полей фильтра */
class FilterHeadBlock extends Component {
	render() {
		return (
			<div>
				<h2>{this.props.Title}</h2>
				<FilterIconButton IsOpen={this.props.isOpen} onClick={this.props.toggleFilter} />
			</div>
		)
	}
}

class Filter extends Component {
	/** Сброс локального фильтра таблицы и отправка запроса */
	handleSubmit = () => {
		this.props.store.resetTableFilter();
		this.props.getData();
	}
	
	render() {
		return(
			<MainFilterBlock
				Filter={this.props.store.Filter}
				IsOpen={this.props.isOpen}
				Preset="month"
				MaxDate={this.props.MaxDate}
				CanDownload={!_.isUndefined(this.props.store.Filter.OutForm)}
				onSubmit={this.handleSubmit}
			>
							{!_.isUndefined(this.props.store.Filter.Type) &&
								<Selectize
									Id="Type"
									Title="Тип продукта"
									Value={this.props.store.Filter.Type}
									List={this.props.store.Types}
									isClearable={false}
									onChange={(value, id) => this.props.store.Filter.collect(id, value)}
								/>
							}
							{!_.isUndefined(this.props.store.Filter.WorkShopIds) &&
								<Selectize
									Id="WorkShopIds"
									Title="Цеха"
									Value={this.props.store.Filter.WorkShopIds}
									List={toSelectList(this.props.store.WorkShops)}
									Multi={true}
									onChange={(value, id) => this.props.store.Filter.collect(id, value)}
								/>
							}
							{!_.isUndefined(this.props.store.Filter.SectionIds) &&
								<Selectize
									Id="SectionIds"
									Title="Разделы"
									Value={this.props.store.Filter.SectionIds}
									List={toSelectList(this.props.store.Sections)}
									Multi={true}
									onChange={(value, id) => this.props.store.Filter.collect(id, value)}
								/>
							}
							{!_.isUndefined(this.props.store.Filter.ProductIds) &&
								<Selectize
									Id="ProductIds"
									Title="Товары"
									Value={this.props.store.Filter.ProductIds}
									List={toSelectList(this.props.store.Products)}
									Multi={true}
									onChange={(value, id) => this.props.store.Filter.collect(id, value)}
								/>
							}
							{!_.isUndefined(this.props.store.Filter.CityId) &&
								<Selectize
									Id="CityId"
									Title="Город"
									Value={this.props.store.Filter.CityId}
									List={toSelectList(this.props.store.Cities)}
									isClearable={false}
									onChange={(value, id) => this.props.store.Filter.collect(id, value)}
								/>
							}
							{!_.isUndefined(this.props.store.Filter.FilialIds) &&
								<Selectize
									Id="FilialIds"
									Title="Филиалы"
									Value={this.props.store.Filter.FilialIds}
									List={toSelectList(this.props.store.Filials)}
									Multi={true}
									onChange={(value, id) => this.props.store.Filter.collect(id, value)}
								/>
							}
							{!_.isUndefined(this.props.store.Filter.StockIds) &&
								<Selectize
									Id="StockIds"
									Title="Склады"
									Value={this.props.store.Filter.StockIds}
									List={toSelectList(this.props.store.Stocks)}
									Multi={true}
									onChange={(value, id) => this.props.store.Filter.collect(id, value)}
								/>
							}
							{!_.isUndefined(this.props.store.Filter.ProviderIds) &&
								<Selectize
									Id="ProviderIds"
									Title="Поставщики"
									Value={this.props.store.Filter.ProviderIds}
									List={toSelectList(this.props.store.Providers)}
									Multi={true}
									onChange={(value, id) => this.props.store.Filter.collect(id, value)}
								/>
							}
							{!_.isUndefined(this.props.store.Filter.CancelReasonIds) &&
								<Selectize
									Id="CancelReasonIds"
									Title="Причины списания"
									Value={this.props.store.Filter.CancelReasonIds}
									List={toSelectList(this.props.store.CancelReasons)}
									Multi={true}
									onChange={(value, id) => this.props.store.Filter.collect(id, value)}
								/>
							}
			</MainFilterBlock>
		)
	}
}
Filter = observer(Filter)

class TableBlock extends Component {
	render() {
		return (
			<div>
				{!this.props.IsSendRequest && <div className="loader"><img src={pageLoader} alt="logo" /></div> }
				{this.props.IsSendRequest && !this.props.IsEmptyResponse &&
					<div className={'reportTable ' + (this.props.TableClass || "")}>
						<TitleRow 
							Columns={this.props.Columns} 
							Filter={this.props.TableFilter} 
							onChange={this.props.onChange}
						/>
						{_.map(this.props.Report, (item,i) => {
							return(<HeadRow Columns={this.props.Columns} Item={item} key={"h_" + i}
								Details={this.props.Details} />)
						})}
						{!_.isUndefined(this.props.Total && !_.isEmpty(this.props.Total)) &&
							<TotalRow Columns={this.props.Columns} Item = {this.props.Total} />
						}
					</div>
				}
				{this.props.IsSendRequest && this.props.IsEmptyResponse && 
					<EmptyResultInformer Description="Измените параметры поиска и попробуйте ещё раз" />
				}
			</div>
		)
	}
}
TableBlock = observer(TableBlock);

class TitleRow extends Component {
	render() {
		return(
			_.map(this.props.Columns, (column, i) => {
				return(<span className='title form' key={"t_" + i}>
					{column.Title}
					{column.Search &&
						<TextInput
							Id={column.Id}
							RowClass="nomargin"
							Value={this.props.Filter[column.Id] || ""}
							onChange={(value, id) => { this.props.onChange(id, value); }}
						/>
					}
					{_.map(column.Switches, (item) => {
						return <CheckFilter
							key={item.Id}
							Id={item.Id}
							Title={item.Title}
							Value={this.props.Filter[item.Id] || false}
							RowClass="nomargin"
							onChange={(value, id) => { this.props.onChange(id, value); }}
						/>
					})}
				</span>)
			})
		)
	}
}
TitleRow = observer(TitleRow);

class HeadRow extends Component {
	render() {
		return(
			<>	
				{_.map(this.props.Columns, (column, i) => {
					if (column.Id === "Action")
						return(<p className={'group action'}  key={"g_" + i}>&nbsp;</p>)

					const value = column.Render ? column.Render(this.props.Item)
						: (!_.isUndefined(this.props.Item[column.Id]) ? this.props.Item[column.Id] : "");

					return(<p className={'group form' + (i === 0 ? " name" : "")} key={"g_" + i}>{value}</p>)
				})}
				{_.map(this.props.Item.Items, (item, k) => {
					return(<SimpleRow Item={item} key={"r_" + k} Columns={this.props.Columns} 
						Details={this.props.Details} />)
				})}
			</>
		)
	}
}

class SimpleRow extends Component {
	constructor(props) {
		super(props);
		this.state = { isOpen : false }
	}

	render() {
		const Details = this.props.Details;

		return(
			<>
				{_.map(this.props.Columns, (column, i) => {
					if (column.Id === "Action" && !_.isUndefined(this.props.Item.Items) && !_.isEmpty(this.props.Item.Items) && !_.isUndefined(this.props.Details))
						return(
							<p className={(this.props.Item.RowClass || "") + ' action ' + (this.state.isOpen ? " active" : "")}  key={"r_" + i}>
								<ExpandIconButton IsOpen={this.state.isOpen}
									onClick={() => this.setState({ isOpen : !this.state.isOpen })} />
							</p>
						)

					const value = column.Render ? column.Render(this.props.Item)
						: (!_.isUndefined(this.props.Item[column.Id]) ? this.props.Item[column.Id] : "");

					return(<p className={(this.props.Item.RowClass || "") + (i === 0 ? " name" : "")} key={"r_" + i}>{value}</p>)
				})}
				{this.state.isOpen && <Details Items={this.props.Item.Items} />}
			</>
		)
	}
}

class TotalRow extends Component {
	render() {
		return(
			<>
				<p className='total name'>ИТОГО</p>
				{_.map(this.props.Columns, (column, i) => {
					if (column.Id !== "Name")
						return(<p className="total" key={"t_" + i}>{column.Render
							? column.Render(this.props.Item)
							: (!_.isUndefined(this.props.Item[column.Id]) ? this.props.Item[column.Id] : "")}
						</p>)
				})}
			</>
		)
	}
}
